import { parseCellKey } from 'components/CellAnnotationValueViewer/types';
import type {
  CellAnnotationWireEntry,
  CellAnnotationWireMap,
} from 'components/CellAnnotationValueViewer/types';
import { foldEntry } from './foldEntry';
import type { WireByCellKey } from './types';

// Split a dirty cell-annotation payload into one cell_annotations map per
// Security parent, keyed by id (persisted) or synthetic `ref_<security_ref>`
// (unsaved new column). Same `(parentId -> fieldAlias -> annotationType ->
// entry)` shape as the FOD / CFL splitters; the cap-table securities save hook
// folds the resolved map onto each security before the PUT.

export interface SplitDirtyForSecuritySave {
  securityCellAnnotations: Record<string, CellAnnotationWireMap>;
}

export const splitDirtyForSecuritySave = (
  payload: WireByCellKey
): SplitDirtyForSecuritySave => {
  const result: SplitDirtyForSecuritySave = { securityCellAnnotations: {} };

  if (!payload) {
    return result;
  }

  Object.entries(payload).forEach(([cellKey, entry]) => {
    const parsed = parseCellKey(cellKey);
    if (!parsed || parsed.parentType !== 'security') {
      return;
    }
    foldEntry(
      result.securityCellAnnotations,
      parsed.parentId,
      parsed.fieldAlias,
      parsed.annotationType,
      entry as CellAnnotationWireEntry
    );
  });

  return result;
};
